import { Injectable } from '@angular/core';
import { RouteProvider } from '../route/route';
import { AuthProvider } from '../../providers/authorization';
import { LoggerProvider, LoggerEvent, LoggerLevel } from '../../providers/logger/logger';
import { TranslateService } from '@ngx-translate/core';
import { RegisterProvider } from '../../providers/register/register';
import { FeatureFlagTypes, UtilsProvider } from '../../providers/myria/utils-provider';
import { APP_CONFIG, Env } from '../../environment';
import { COUNTRY_SETTINGS } from '../../providers/myria/app-variables';
import { INavInfo } from '../../model/models/layout/nav-info.interface';
import { HelpProvider } from '../../providers/help/help';
import { LoginProvider } from '../../providers/myria/login-provider';
import { BehaviorSubject } from 'rxjs';
import { SegmentLocationNames } from '../../model/types/analytics.const';
import { Platform } from 'ionic-angular';
import { OrderProvider } from '../../providers/order/order';
import { EKYC_PAGEFROM } from '../../model/models/ekyc-singpass/ekyc-singpass.model';

declare var window: any;
@Injectable()
export class DeeplinkProvider {

    private onLogin = null;
    public static params;
    deeplinkPromoCode = null;
    referralRevision = 0;
    referralChanges = new BehaviorSubject<number>(0);
    deeplinkCountryCode = null;
    referringLink = null;
    deeplinkPage = null;
    showReferralModal = null;
    deeplinkPendingOrder: boolean = false;
    isDeeplinkFlowOneapp: boolean = false;
    deeplinkOptInMarketingNotifications: BehaviorSubject<any> = new BehaviorSubject(false);
    deeplinkOptInMarketTransactNotifications: BehaviorSubject<any> = new BehaviorSubject(false);
    deeplinkGetRiaCardNotifications: BehaviorSubject<any> = new BehaviorSubject(false);
    initPromise;
    initResolve;
    agent;
    public static deepLinkData;
    public static canRedirectToSingpass: boolean = false; //  Prevent reopening from the branch level if the promise fails to resolve
    public static singpassPrvAccessCode: string = null; // Avoid triggering a reopen at the branch level when the Singpass access code is the same
    public static redirectPspResult: string = null;

    constructor(
        private routeProvider: RouteProvider,
        private translate: TranslateService,
        private registerProvider: RegisterProvider,
        private utils: UtilsProvider,
        private helpProvider: HelpProvider,
        private loginProvider: LoginProvider,
        private orderProvider: OrderProvider,
        private platform: Platform,
    ) {
        this.initPromise = new Promise((resolve) => {
            this.initResolve = resolve;
        })
    }

    async pushURLHandeler(response) {
        console.log("onNotificationOpen response", JSON.stringify(response));
        let params: IDeeplinkParams = new IDeeplinkParams();
        params.id = new URLSearchParams(response.query || response.search).get("id");
        params.page = new URLSearchParams(response.query || response.search).get("page");
        params.paymentMethod = new URLSearchParams(response.query || response.search).get('paymentMethod');
        if (params.page) {
            if (!RouteProvider.ready || !AuthProvider.isLoggedIn()) {
                DeeplinkProvider.params = params;
                this.onLogin = this.processDeeplink.bind(this);
            }
            else
                this.processDeeplink(params);
        }
    }

    private isJsonValid(str) {
        try {
           var newStr  = atob(str);
           return JSON.parse(newStr);;
        } catch (e) {
          return null;
        }
      }

   async handleCustomAction(response, dataParam: any = null) {
        if (response && response.length > 0){
            const queryIndex = response.indexOf("?");
            if (queryIndex > -1) {
                const search = new URLSearchParams(response.substring(queryIndex + 1));
                dataParam = { ...this.utils.paramsToObject(search), ...(dataParam || {}) };
                response = response.substring(0, queryIndex);
            }
            // Check if we can handle the page directly
            const jsonObject = this.isJsonValid(response);
            if (jsonObject == null || response == "SettingsHelpPage") {
                DeeplinkProvider.params = dataParam ? {"page":response, "data":dataParam} : {"page":response};
            }else {
                // Base64 response and handle dynamic parameters in data
                if(dataParam) {
                    jsonObject.data = dataParam;
                }
                DeeplinkProvider.params = jsonObject
            }

            if (DeeplinkProvider.params){

                if (DeeplinkProvider.params.getRiaCard !== undefined) {
                    this.setDeeplinkGetRiaCardNotifications(DeeplinkProvider.params.getRiaCard);
                } else if (DeeplinkProvider.params.optInMarketing !== undefined) {
                    this.utils.openEmailMarketingSubscriptionModal(() => {
                        console.log("Email Marketing Subscription Modal Closed - NO");
                    }, () => {
                        console.log("Email Marketing Subscription Modal Closed - Yes");
                        this.setDeeplinkOptInMarketTransactNotifications(true);
                    })
                }
                else
                if (DeeplinkProvider.params.page == "SettingsHelpPage") {
                    // Hardcoded for now as we don't have specific page for this flow.
                    this.helpProvider.openHelp();
                }else{
                    var withAnimation = true;
                    if (DeeplinkProvider.params.page == "LanguageSelectionPage"){
                        withAnimation = false;
                    }
                    this.processDeeplink(DeeplinkProvider.params, withAnimation);
                }
            }
        }
   }

    deeplinkParamsHandeler(params) {
        if (params.page) {
            this.setDeepLinkShowReferralParam(params.showReferralModal);
            if (!RouteProvider.ready || (!AuthProvider.isLoggedIn() && !this.loginProvider.isLiteUser())) {
                if(params.page === 'LanguageSelectionPage'){
                    this.redirectPage(this.routeProvider.pages.PreLoginPage, null, {action: params.page}, false);
                }else {
                    params.data = this.mapDeepLinkData(params);
                    DeeplinkProvider.params = params;
                    this.onLogin = this.processDeeplink.bind(this);
                }
            }
            else {
                params.data = this.mapDeepLinkData(params);
                this.processDeeplink(params);
            }
        }
    }

     async processDeeplink(params = DeeplinkProvider.params, withAnimation = true) {
        const page = this.routeProvider.pages[params.page];
        let deepLinkData: any= {};
        try {
          deepLinkData = params.data || {};
          if (typeof params.data === 'string'){
              deepLinkData = JSON.parse(params.data);
          }
          if(!deepLinkData.transactionId && params.transactionId) { //in case if transaction id was sent as url Paramater, it needs to be included in deepLinkData params.
            deepLinkData.transactionId = params.transactionId;
          }
          if (params.page.indexOf('TabsHome') > -1) {
              DeeplinkProvider.deepLinkData = deepLinkData;
              await this.routeProvider.setRoot(page);
              DeeplinkProvider.deepLinkData = null;
          } else {
                await this.routeProvider.setRoot(this.routeProvider.pages.TabsHomePage);
                const canRedirect = await this.canRedirect(page);
                if (canRedirect) {
                    this.redirectPage(page, params.id, deepLinkData, withAnimation);
                }
                else {
                    LoggerProvider.log(this, LoggerLevel.Debug, LoggerEvent.DeepLinking, 'Page cannot be redirected: ' + page.page);
                }
          }
        } catch(err) {
          LoggerProvider.log(this, LoggerLevel.Debug, LoggerEvent.DeepLinking, 'Page cannot be deeplinked: ' + page.page);
        }
        this.setDeepLinkShowReferralParam(null);
        this.onLogin = null;
    }

    redirectPage(page: INavInfo, id, deepLinkData = null, withAnimation = true) {
        this.routeProvider.openModal(page, { id: id, deepLinkData: deepLinkData }, null, null, withAnimation);
    }

    async processDeepLinkRegistration(data) {
        //wait until translate module is loaded
        await new Promise((resolve) => { this.checkTranslation(resolve); });

        let deeplinkData = this.mapDeepLinkData(data);
        if (deeplinkData.countryCode === 'SG') {
            // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TEMPORARY !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // hotfix for SG because it sends countryCode 'SG' instead of the phone countrycode and is missing countryIsoCode
            deeplinkData.countryCode = '65';
            deeplinkData.countryIsoCode = 'SG';
        }
        if (deeplinkData.countryCode === 'MY') {
            // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TEMPORARY !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // hotfix for MY because it sends countryCode 'MY' instead of the phone countrycode and is missing countryIsoCode
            deeplinkData.countryCode = '60';
            deeplinkData.countryIsoCode = 'MY';
        }
        if (deeplinkData.countryCode === 'AU') {
            // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TEMPORARY !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // hotfix for AU because it sends countryCode 'AU' instead of the phone countrycode and is missing countryIsoCode
            deeplinkData.countryCode = '61';
            deeplinkData.countryIsoCode = 'AU';
        }
        if (deeplinkData.countryCode === '1') {
            // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TEMPORARY !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            deeplinkData.countryCode = '1';
            deeplinkData.countryIsoCode = 'US';
            if(deeplinkData.userCountry === 'CA') {
                deeplinkData.countryIsoCode = 'CA';
            }
        }
        if (deeplinkData.countryCode === '49') {
            // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TEMPORARY !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            deeplinkData.countryCode = '49';
            deeplinkData.countryIsoCode = 'DE';
        }
        let analyticsReferralData = null;
        this.registerProvider.agentReferralData = this.registerProvider.mapDeepLinkAgentReferralData(data);
        if(this.registerProvider.agentReferralData) {
            let {userId,deeplink,tellerId,...analyticsAgentReferralData} = this.registerProvider.agentReferralData;
            analyticsReferralData = analyticsAgentReferralData;
        }

        let params = {
            msg: this.translate.instant('global.genericLoadingText'),
            action: 'verify-deeplink',
            token: deeplinkData.token,
            isEncrypted: deeplinkData.isEncrypted,
            userphone: deeplinkData.username || '',
            countryCode: deeplinkData.countryCode,
            countryIsoCode: deeplinkData.countryIsoCode,
            userCountry: deeplinkData.userCountry,
            analyticsAgentReferralData: analyticsReferralData
        };
        await this.utils.hideVueBridgeIfVisible();
        this.routeProvider.setRoot(this.routeProvider.pages.RegistrationDeeplinkingPreparePage, params, false);
    }

    async processReferralDeepLinkRegistration(data) {
        //wait until translate module is loaded
        await new Promise((resolve) => { this.checkTranslation(resolve); });

        let deeplinkData = this.mapDeepLinkData(data);
        this.setDeeplinkCountry(deeplinkData.countryCode);
        this.setDeeplinkPromoCode(deeplinkData.promoCode);
        this.setDeeplinkUrl(deeplinkData.referringLink);

        await this.utils.navigateToReferralSignup(deeplinkData.countryIsoCode, () => this.openNativeReferralSignup(deeplinkData));
    }

    private async openNativeReferralSignup(deeplinkData) {
        await this.utils.hideVueBridgeIfVisible();
        try {
            await this.utils.checkIsLiteRegistrationSettingEnabled();
        } catch (ex) {
            //RmtPopupComponent.showExceptionWithLogTranslation(this, '', 'global.myRia.jsonContent.OopsInfo');
            this.utils.setIsLiteRegistrationEnabled(false);
        }
        let page = this.utils.getIsLiteRegistrationEnabled() ? this.routeProvider.pages.RlUserCountryPage : this.routeProvider.pages.UserCountryPage;


        this.routeProvider.openModal(page, {
            countryCode: deeplinkData.countryIsoCode,
            analyticsLocation: SegmentLocationNames.Registration,
            onChangeCountry: async (country) => {
                this.registerProvider.setCurrentRegistration({}); // reset current registration
                let params = { selectedCountry: country };
                await this.utils.continueRegistrationPage(params);
                return true;
            }
          });
    }

    setDeeplinkPendingOrder(isPendingOrder: boolean) {
        this.deeplinkPendingOrder = isPendingOrder;
    }

    isDeeplinkPendingOrder() {
        return this.deeplinkPendingOrder;
    }

    setDeeplinkPromoCode(promoCode) {
        this.deeplinkPromoCode = promoCode;
        this.referralRevision++;
        this.referralChanges.next(this.referralRevision);
    }

    clearDeeplinkReferral(revision?: number) {
        if (revision !== undefined && revision !== this.referralRevision) return;
        this.deeplinkCountryCode = null;
        this.referringLink = null;
        this.setDeeplinkPromoCode(null);
    }

    setDeeplinkCountry(countryCode) {
        this.deeplinkCountryCode = countryCode;
    }

    getDeeplinkPromoCode(countryCode) {
        return this.deeplinkCountryCode == countryCode ? this.deeplinkPromoCode : null;
    }

    setDeeplinkUrl(referringLink) {
        this.referringLink = referringLink;
    }

    getDeeplinkUrl(countryCode) {
        return this.deeplinkCountryCode == countryCode ? this.referringLink : null;
    }

    setDeepLinkShowReferralParam(showReferralModal) {
        this.showReferralModal = showReferralModal;
    }

    getDeepLinkShowReferralParam() {
        return this.showReferralModal;
    }

    private mapDeepLinkData(data) {
        let deeplinkData = new IDeeplinkData()
        deeplinkData.id = data['~id'];
        deeplinkData.deepLinkPath = data['$deeplink_path'];
        deeplinkData.clickedTimestamp = data['+click_timestamp'];
        deeplinkData.token = data['Token'];
        deeplinkData.isEncrypted = data['RetVal'] === 20 ? false : true;
        deeplinkData.referringLink = data['~referring_link'];
        deeplinkData.username = data['Username'];
        deeplinkData.transactionId = data['transactionId'];
        deeplinkData.isFirstSession = data['+is_first_session'];

        /*
        'CountryCode' field is used for RAF deeplinks, in case it is a registration deeplink the field is 'countryCode'
        and the ISOcode will be calculated. Both have different flows, it remains to open Spike to synchronize the structure of the deeplinks.
         */
        deeplinkData.countryCode = data['countryCode'] ? data['countryCode'] : "60";
        if (data['CountryCode']) {
            deeplinkData.countryCode = data['CountryCode'];
            deeplinkData.CountryDeeplinkEventType = data['CountryDeeplinkEventType'];
            this.registerProvider.countryDeeplinkEventType = data['CountryDeeplinkEventType'];
            if (data['CountryIsoCode'])
                deeplinkData.countryIsoCode = data['CountryIsoCode'];
            else
                deeplinkData.countryIsoCode = data['CountryCode'];
        } else if (data['IsoCode'])
            deeplinkData.countryIsoCode = data['IsoCode'];
        else {
            var matchedRegion = APP_CONFIG.regions.find(region => region.defaultCountryCodeFrom.toString() === deeplinkData.countryCode);
            if (matchedRegion) deeplinkData.countryIsoCode = matchedRegion.defaultCountryFrom;
        }

        if (data['UserCountry'])
            deeplinkData.userCountry = data['UserCountry'];

        if (data['PromoCode'])
            deeplinkData.promoCode = data['PromoCode'];
        const calculatorDeeplinkData = this.mapCalculatorDeeplinkData(data);
        deeplinkData = { ...calculatorDeeplinkData, ...deeplinkData }; //deeplinkData properties will override calculatorDeeplinkData ones in case of conflict
        return deeplinkData;
    }

    mapCalculatorDeeplinkData(data) {
        let deeplinkBody: any= {};
        if (data.data) {
            deeplinkBody = data.data;
            if (typeof data.data === 'string') {
                try {
                    deeplinkBody = JSON.parse(data.data);
                } catch (e) {
                    return {};
                }
            }
        }
                // Support nested (data.data) params and top-level Branch params (OM-18681)
        const amountFrom = deeplinkBody['AmountFrom'] || deeplinkBody['amountFrom'] || data['amount'];
        const amountTo = deeplinkBody['AmountTo'] || deeplinkBody['amountTo'];
        const countryTo = deeplinkBody['CountryTo'] || deeplinkBody['countryTo'] || data['countryTo'];
        const deliveryMethod = deeplinkBody['DeliveryMethod'] || deeplinkBody['deliveryMethod'] || data['payoutMethod'];
        const paymentMethod = deeplinkBody['PaymentMethod'] || deeplinkBody['paymentMethod'] || data['paymentMethod'];
        const promoCode = deeplinkBody['PromoCode'] || deeplinkBody['promocode'] || deeplinkBody['promoCode'];
        const currencyTo = deeplinkBody['CurrencyTo'] || deeplinkBody['currencyTo'] || data['currencyTo'];
        const countryFrom = deeplinkBody['CountryFrom'] || deeplinkBody['countryFrom'] || data['countryFrom'];
        let deeplinkData: any= {};
        if (promoCode)
            deeplinkData.promoCode = promoCode;
        if (amountFrom)
            deeplinkData.amountFrom = amountFrom;
        if (amountTo)
            deeplinkData.amountTo = amountTo;
        if (countryTo)
            deeplinkData.countryTo = countryTo;
        if (deliveryMethod)
            deeplinkData.deliveryMethod = deliveryMethod;
        if (paymentMethod)
            deeplinkData.paymentMethod = paymentMethod;
        if (currencyTo)
            deeplinkData.currencyTo = currencyTo;
        if (countryFrom)
            deeplinkData.countryFrom = countryFrom;
        if (data['googleLiteDeeplink'])
            deeplinkData.googleLiteDeeplink = true;
        return deeplinkData;
    }

    checkTranslation(resolve, count = 0) {
        // for some reason although translateService.use is finished sometimes it is not loaded yet
        const translateKey = 'global.genericLoadingText';
        const translated = this.translate.instant(translateKey);
        if (!translated || !translated.indexOf || translated.indexOf(translateKey) === 0) {
            if (count < 25) {
                window.setTimeout(() => {
                    count++;
                    this.checkTranslation(resolve, count);
                }, 50);
                return;
            }
            LoggerProvider.warning(this, LoggerEvent.ComponentException, 'Test translation failed (tries ' + count + ': ' + translated);
        }
        else
            LoggerProvider.info(this, 'Test translation successful (tries ' + count + '): ' + translated);
        resolve(true);
    }

    async canRedirect(page: INavInfo) {
        let canRedirect = true;
        if (page.page === this.routeProvider.pages.ReferAFriendNewPage.page) {
            try {
                let referAFriendAvailable = await UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.ShowReferAFriendCTA);
                canRedirect = referAFriendAvailable;
            } catch (ex) {
                canRedirect = false;
            }
        }

        return canRedirect;
    }

    //TODO :- To be removed in future 
    setDeeplinkOptInMarketingNotifications(optInMarketingNotifications: boolean) {
        this.deeplinkOptInMarketingNotifications.next(optInMarketingNotifications);
    }
    
    setDeeplinkOptInMarketTransactNotifications(optInMarketingNotifications: boolean) {
        this.deeplinkOptInMarketTransactNotifications.next(optInMarketingNotifications);
    }

    setDeeplinkGetRiaCardNotifications(getRiaCard: boolean) {
        this.deeplinkGetRiaCardNotifications.next(getRiaCard);
    }

    setDeeplinkDataVueBridge() {
        this.isDeeplinkFlowOneapp = true;
    }

    setReady() {
        this.initResolve(true);
    }

    async getOnLogin() {
        await this.initPromise;
        return this.onLogin;
    }

    async handleOnLogin() {
        const onLogin = await this.getOnLogin();
        if (onLogin) {
            onLogin();
            return true;
        }
        return false;
    }

    async processToSingpassDeeplink(data, msgURL, isoldDeeplink: boolean = false){
        let accessCode = '', state = '', pageFrom ='', url;
        // IOS old build to redirect and close modal ASWebAuthSession
        if (msgURL && msgURL.indexOf('riamoneytransfer://deeplink/singpass') > -1) {
            LoggerProvider.info(this, 'deeplink is custom scheme from ASWebAuthSession', msgURL);
            url = new URL(msgURL.toString());
        } else if(data['+non_branch_link']){
            // New URL re-direction for both Android and iOS
            LoggerProvider.info(this, 'deeplink is non branch link from custom tab', data);
            url = new URL(data['+non_branch_link'].toString());
        } else {
            LoggerProvider.info(this, 'singpass deeplink not getting re-direction url', {data: data, msgURL: msgURL});
        }

        if(isoldDeeplink){
            LoggerProvider.info(this, 'deeplink is old deeplink', data);
            const result = new URLSearchParams(new URL(`${APP_CONFIG.API_URL}` + data['$deeplink_path']).search)
            accessCode = result.get('accessCode') ? result.get('accessCode') : '';
            state = result.get('state') ? result.get('state') : '';
            pageFrom = result.get('pageFrom') ? result.get('pageFrom') : '';
        } else {
            LoggerProvider.info(this, 'new deeplink set value', data);
            if(url){
                const paramsFromString = new URLSearchParams(url.search);
                accessCode = paramsFromString.get("code") ? paramsFromString.get('code') : '';
                state = paramsFromString.get("state") ? paramsFromString.get('state') : '';
                pageFrom = paramsFromString.get("pageFrom") ? paramsFromString.get('pageFrom') : '';
            }
        }

        if(DeeplinkProvider.canRedirectToSingpass){
            let isWaiting: boolean = true;
            if(DeeplinkProvider.singpassPrvAccessCode == accessCode) {
                // Avoid triggering multiple redirects for a single access code; fallback to manual registration on retry
                isWaiting = false;
                pageFrom =  (pageFrom == EKYC_PAGEFROM.REGISTER) ? EKYC_PAGEFROM.SETTINGS : pageFrom;
            }
            if(!DeeplinkProvider.singpassPrvAccessCode) DeeplinkProvider.singpassPrvAccessCode = accessCode;
            else if(DeeplinkProvider.singpassPrvAccessCode && DeeplinkProvider.singpassPrvAccessCode !== accessCode) DeeplinkProvider.singpassPrvAccessCode = accessCode;

            try {
                await this.routeProvider.replace(this.routeProvider.pages.SingpassVerificationFailedPage, {
                    authorization_code : accessCode,
                    kycId: state,
                    pageLoadFrom: pageFrom,
                    isWaiting: isWaiting
                });
                if (this.routeProvider.isLastPushedPage(this.routeProvider.pages.SingpassVerificationFailedPage)) {
                    DeeplinkProvider.canRedirectToSingpass = false;
                }
            } catch (ex) {
                LoggerProvider.exception(this, ex, LoggerEvent.DeepLinking, 'Singpass redirect navigation failed');
            }
        } else
            LoggerProvider.info(this, 'Already redirected to Singpass');

        if (this.platform.is('ios')) {
            window.plugins.ASWebAuthSession.close();
        }
    }

    async handlePspRedirectLink(msg) {
        const redirectResult = await this.orderProvider.getPspRedirectResult(msg)
        if (redirectResult) {
            this.processToPspRedirect(redirectResult)
            LoggerProvider.info(this, 'Set redirect result for PSP');
        }
    }

    async processToPspRedirect(redirectResult) {
        LoggerProvider.info(this, 'Process redirect result for PSP');
        this.orderProvider.handlePspRedirect(redirectResult);
    }

    getURL(url) {
        let urlSignicat = '';
        if (url.indexOf('https://riamoneytransfer.test-app.link/') > -1)
            urlSignicat = url.replace('https://riamoneytransfer.test-app.link/', '')
        else if (url.indexOf('https://riamoneytransfer.app.link/') > -1)
            urlSignicat = url.replace('https://riamoneytransfer.app.link/', '')
        else if (url.indexOf('https://riamoneytransfer.app.link/') > -1)
            urlSignicat = url.replace('https://riamoneytransfer.app.link/', '')
        return urlSignicat;
    }
}

export class IDeeplinkParams {
    page: string;
    id: string;
    paymentMethod: string;
}

export class IDeeplinkData {
    CountryDeeplinkEventType: number;
    deepLinkPath: string;
    username: string;
    clickedTimestamp: number;
    id: string;
    isFirstSession: boolean;
    token: string;
    referringLink: string;
    countryCode: string;
    countryIsoCode: string;
    isEncrypted: boolean;
    promoCode: string;
    transactionId: string;
    message: string;
    userCountry: string;
}



// WEBPACK FOOTER //
// ./src/providers/marketing/deeplink.ts